import { render, staticRenderFns } from "./UcBillingMultiplierBadge.yaml?vue&type=template&id=d6f1538a&component"
import script from "./UcBillingMultiplierBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcBillingMultiplierBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports